<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="apply"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="申请时间">
        {{ apply.add_time | timeToYmdHi }}
      </el-form-item>

      <el-form-item label="申请者">
        <v-avatar-nickname
          :value="apply.avatar"
          :nickname="apply.nickname"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="申请门店">
        {{ apply.store_name }}
      </el-form-item>

      <el-form-item label="课程难度名称">
        {{ apply.difficulty_name }}
      </el-form-item>

      <el-form-item label="审核状态">
        <span v-if="!isLoading && !isLoadingError && currentApplyState" :class="`${currentApplyState.tagType}-color`">
          {{ currentApplyState.name }}
        </span>
      </el-form-item>

      <template v-if="apply.update_time && (canViewReviewInfo)">
        <el-form-item :label="`${apply.apply_state === applyStates.revoked.value ? '撤回' : '审核'}时间`">
          {{ apply.update_time | timeToYmdHi }}
        </el-form-item>

        <el-form-item v-if="apply.apply_state === applyStates.rejected.value || apply.apply_state === applyStates.passed.value" label="审核人">
          <v-avatar-nickname
            :value="apply.update_avatar"
            :nickname="apply.update_nickname"
            :is-center="false"
          />
        </el-form-item>
      </template>

      <el-form-item label="驳回原因" v-if="apply.apply_state === applyStates.rejected.value && (canViewReviewInfo)">
        {{ apply.reject_reason }}
      </el-form-item>

      <template v-if="!isLoading && !isLoadingError && apply.apply_state === applyStates.review.value">
        <template v-if="isAdministrator">
          <el-form-item label="审核结果">
            <el-radio v-model="isReject" :label="0" :disabled="isExamining">通过</el-radio>
            <el-radio v-model="isReject" :label="1" :disabled="isExamining">驳回</el-radio>
          </el-form-item>
          <el-form-item v-if="isReject" label="驳回原因" prop="reject_reason">
            <el-input
              class="clearable-word-limit-input"
              v-model="apply.reject_reason"
              maxlength="128"
              placeholder="请输入驳回原因"
              show-word-limit
              clearable
              :disabled="isExamining"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleExamine" :loading="isExamining">完成审核</el-button>
            <el-button @click="RouteConfig.courseDifficultyAddApplyList.back">返回</el-button>
          </el-form-item>
        </template>
        <el-form-item v-else>
          <el-button type="primary" @click="handleRevoke" :loading="isExamining">撤回</el-button>
          <el-button @click="RouteConfig.courseDifficultyAddApplyList.back">返回</el-button>
        </el-form-item>
      </template>
      <el-form-item v-else>
        <el-button @click="RouteConfig.courseDifficultyAddApplyList.back">返回</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, pass, reject, revoke } from '@/api/course-difficulty-add-apply';
import { mapGetters } from 'vuex';
import { applyStates, findApplyState } from '@/enums/applyStates';

export default {
  name: RouteConfig.courseDifficultyAddApplyDetail.name,
  data: () => ({
    RouteConfig,
    isExamining: false,
    isLoading: false,
    isLoadingError: false,
    isReject: 0,
    applyStates,
    apply: {
      add_time: 0,
      update_time: 0,
      nickname: '',
      avatar: '',
      store_name: '',
      difficulty_name: '',
      store_id: 0,
      apply_state: applyStates.review.value,
      reject_reason: '',
      update_avatar: '',
      update_nickname: '',
    },
    rules: {
      reject_reason: [{ required: true, message: '请输入驳回原因', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.apply.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
    currentApplyState() {
      const result = findApplyState(this.apply.apply_state);
      return result.length ? result[0] : undefined;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      const { apply } = this;
      const newApply = {};
      Object.keys(data).forEach(key => {
        if (key in apply) newApply[key] = data[key];
      });
      Object.assign(apply, newApply);
      this.isLoading = false;
    },
    handleExamine() {
      if (this.isExamining) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isExamining = true;
        this.isReject ? this.handleReject() : this.handlePass();
      });
    },
    async handlePass() {
      const { isError } = await pass(this.id, { update_time: this.apply.update_time });
      this.isExamining = false;

      if (!isError) RouteConfig.courseDifficultyAddApplyList.push({ apply_state: applyStates.passed.value });
    },
    async handleReject() {
      const { isError } = await reject(this.id, { update_time: this.apply.update_time, reject_reason: this.apply.reject_reason });
      this.isExamining = false;

      if (!isError) RouteConfig.courseDifficultyAddApplyList.push({ apply_state: applyStates.rejected.value });
    },
    async handleRevoke() {
      if (this.isExamining) return;

      this.isExamining = true;
      const { isError } = await revoke(this.id, { update_time: this.apply.update_time });
      this.isExamining = false;
      if (!isError) RouteConfig.courseDifficultyAddApplyList.push({ apply_state: applyStates.revoked.value });
    },
  },
};
</script>
